export type PricesCityAnalyticsLocation = "rp_apartment_prices_city" | "rp_apartment_prices_district" | "rp_apartment_prices_address";

export const PRICES_ADDRESS_ANALYTICS_LOCATION = "rp_apartment_prices_address" satisfies PricesCityAnalyticsLocation;

// The carousel heading - the same list name on every page, in Amplitude, GTM and the slider label.
export const PRICES_OFFERS_LIST_NAME = "Najniższa cena za m² – polecane oferty";
export type PricesCityAnalyticsLocation = "rp_apartment_prices_city" | "rp_apartment_prices_district" | "rp_apartment_prices_address";

export const PRICES_ADDRESS_ANALYTICS_LOCATION = "rp_apartment_prices_address" satisfies PricesCityAnalyticsLocation;

// The carousel heading - the same list name on every page, in Amplitude, GTM and the slider label.
export const PRICES_OFFERS_LIST_NAME = "Najniższa cena za m² – polecane oferty";
